import React from "react";
import { Link } from "react-router-dom";
import { challenges } from "../mock";
import { Check, ArrowRight } from "lucide-react";

const Challenges = () => {
  return (
    <section className="py-24 bg-[#F5F7FB]">
      <div className="container-x">
        <div className="max-w-3xl reveal">
          <span className="tag-chip">Thrive Through Data</span>
          <h2 className="section-title mt-4">
            Next-gen data engineering solutions for enterprise complexity
          </h2>
          <p className="section-sub mt-5">
            We help enterprises design, build, and manage scalable data infrastructure — transforming fragmented data into reliable, AI-ready assets for analytics, automation, and faster business decisions.
          </p>
        </div>

        <div className="mt-14 grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5 reveal">
            <div className="relative rounded-2xl overflow-hidden bg-gradient-to-br from-[#0B1B3B] to-[#132a5c] p-8 text-white">
              <div className="absolute inset-0 grid-lines-bg opacity-40" />
              <div className="relative">
                <h3 className="text-2xl font-bold leading-snug">What enterprise data engineering challenges we solve?</h3>
                <p className="mt-4 text-sm text-slate-300 leading-relaxed">
                  Enterprise data environments are complex, distributed, and constantly evolving. Our data platform approach addresses the most common challenges that prevent organizations from getting reliable, data-driven insights.
                </p>
                <Link to="/insights" className="btn-primary mt-8" data-testid="challenges-insights-button">Know More <ArrowRight size={16} /></Link>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 space-y-4">
            {challenges.map((c, i) => (
              <div key={i} className="reveal group flex items-start gap-4 bg-white border border-slate-200 rounded-xl p-5 hover-lift">
                <div className="h-10 w-10 rounded-lg bg-[#EEF3FF] text-[#1E56E3] flex items-center justify-center font-bold text-sm shrink-0">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="flex-1">
                  <p className="text-[15px] text-slate-700 leading-relaxed">{c}</p>
                </div>
                <Check className="text-emerald-500 opacity-0 group-hover:opacity-100 transition-opacity" size={20} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Challenges;
